<div *ngIf="cardImageFrontSafeResource && !this.teCuidamosSavia">
  <div class="card-section">
    <img
      [src]="cardImageFrontSafeResource"
      alt="card"
      (click)="navTo('card')"
      tappable
    />
    <div class="blurry-border-div"></div>
  </div>

  <div class="text-section mapfre-fs-xs-r">
    <ion-text color="medium-dark">
      <div>
        {{ 'TECUIDAMOS.TC_HOME.TEXT1' | translate }}
      </div>
    </ion-text>

    <ion-text color="medium-dark">
      <div class="content-margin-top">
        {{ 'TECUIDAMOS.TC_HOME.TEXT2' | translate }}
      </div>
    </ion-text>
  </div>

  <div class="navigation-boxes">
    <div analyticsAction="BUTTON" class="navigation-box" (click)="navTo('saving')" tappable>
      <div class="navigation-box__icon">
        <img src="assets/images/tecuidamos/saving.png" />
      </div>
      <div class="navigation-box__text">
        {{ 'TECUIDAMOS.TC_HOME.SAVING_AND_CLOVERS' | translate }}
      </div>
    </div>
    <div analyticsAction="BUTTON"  class="navigation-box" (click)="navTo('service')" tappable>
      <div class="navigation-box__icon">
        <img src="assets/images/tecuidamos/services.png" />
      </div>
      <div class="navigation-box__text">
        {{ 'TECUIDAMOS.TC_HOME.CONSULTANTS_AND_EXPERTS' | translate }}
      </div>
    </div>
    <div analyticsAction="BUTTON"  class="navigation-box" (click)="navTo('raffle')" tappable>
      <div class="navigation-box__icon">
        <img src="assets/images/tecuidamos/raffles.png" />
      </div>
      <div class="navigation-box__text">
        {{ 'TECUIDAMOS.TC_HOME.RAFFLES' | translate }}
      </div>
    </div >
  </div>

  <div class="buttons-section mapfre-fs-xs mapfre-fw-500">
    <ion-button color="primary" expand="block" (click)="navTo('faq')">
      <ion-icon name="help-circle" color="white"></ion-icon>
      {{ 'TECUIDAMOS.TC_HOME.FAQ' | translate }}
    </ion-button>

    <ion-button
      color="medium"
      expand="block"
      fill="clear"
      (click)="navTo('consultation')"
    >
      {{ 'TECUIDAMOS.TC_HOME.QUERY' | translate }}
    </ion-button>
  </div>
</div>

<div *ngIf="this.teCuidamosSavia" class="savia">
  <div class="mapfre-fw-400 mapfre-fs-xl dark-secondary savia__title">
    {{ 'TECUIDAMOS.TC_HOME.WELCOME' | translate}}
  </div>
  <div class="savia__cloverContainer" (click)="onOpenSaviaTecuidamos('userClovers')">
    <div class="mapfre-fw-400 mapfre-fs-xxl">
      {{ teCuidamosState?.redeemPendingClovers != null &&
        teCuidamosState?.redeemPendingClovers != 0 ? (teCuidamosState?.redeemPendingClovers |
        number:'1.2-2': 'es') : 0 }}
    </div>
    <div class="mapfre-fw-400 mapfre-fs-xxs-r medium-dark"> {{ 'TECUIDAMOS.TC_HOME.CLOVERS_SAVIA' | translate | uppercase}}</div>
  </div>

  <ion-button
    class="savia__membershipButton"
    fill="clear"
    color="primary"
    (click)="onOpenSaviaTecuidamos('membershipCard')"
  >
    <img src="assets/images/tecuidamos/membershipCard.svg" />
    <div class="mapfre-mr-s mapfre-ml-sm mapfre-fs-xs-r mapfre-fw-500">{{ 'TECUIDAMOS.TC_HOME.MEMBERSHIP_CARD_ACCESS' | translate}}</div>
  </ion-button>

    <div class="mapfre-fw-400 mapfre-fs-m">
      {{ 'TECUIDAMOS.TC_HOME.DIRECT_ACCESS' | translate}}
    </div>

    <div class="savia__directAccess">
      <ion-buttons
        class="savia__directAccess--box"
        (click)="onOpenSaviaTecuidamos('clovers')"
      >
        <div class="savia__directAccess--img df jc-c ai-c">
          <img src="assets/images/tecuidamos/savingAndClovers.svg" alt="icon"/>
        </div>
        <div class="savia__directAccess--text mapfre-fw-400 mapfre-fs-xs">
          {{ 'TECUIDAMOS.TC_HOME.SAVING_AND_CLOVERS' | translate }}
        </div>
      </ion-buttons>
      <ion-buttons
        class="savia__directAccess--box"
        (click)="onOpenSaviaTecuidamos('experts')"
      >
        <div class="savia__directAccess--img df jc-c ai-c">
          <img src="assets/images/tecuidamos/consultantsAndExperts.svg" alt="icon"/>
        </div>
        <div class="savia__directAccess--text mapfre-fw-400 mapfre-fs-xs">
          {{ 'TECUIDAMOS.TC_HOME.CONSULTANTS_AND_EXPERTS' | translate }}
        </div>
      </ion-buttons>
      <ion-buttons
        class="savia__directAccess--box"
        (click)="onOpenSaviaTecuidamos('raffles')"
      >
        <div class="savia__directAccess--img df jc-c ai-c">
          <img src="assets/images/tecuidamos/raffle.svg" alt="icon"/>
        </div>
        <div class="savia__directAccess--text mapfre-fw-400 mapfre-fs-xs">
          {{ 'TECUIDAMOS.TC_HOME.RAFFLES' | translate }}
        </div>
      </ion-buttons>
    </div>

  <ion-button
    color="primary"
    class="savia__teCuidamos mapfre-fw-500 mapfre-fs-xs-r"
    (click)="onOpenSaviaTecuidamos('teCuidamos')"
  >
    {{ 'TECUIDAMOS.TC_HOME.TECUIDAMOS_ACCESS' | translate}}
  </ion-button>

</div>
